import React, { useState, useEffect } from "react";
import { Table, Input, Button, Space, Popconfirm, message, Modal } from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { API_LIST_STORE, API_DELETE_STORE } from "api/store-managemnt"; // Import your API functions
import EditStore from "views/admin/storeManagement/EditStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import { API_LIST_USER } from "api/user-mangement";
import ViewUser from "views/admin/Users/ViewUser/ViewStore";
import EditUser from "views/admin/Users/EditUser";
import { API_DELETE_USER } from "api/user-mangement";
import { CONSTANTS } from "config/constant";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_GET_WALLET } from "api/Wallet";
import userplace from "../../../assets/img/orders/orderDetail/userplace.png";
import { MdAccountBalance } from "react-icons/md";
import { API_GET_TRANSECTIONS } from "api/Wallet";
import TransactionTable from "./TransactionTable";
const { Column } = Table;
const { TextArea } = Input;
const WalletTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTransection, setLoadingTransection] = useState(false);

  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedTransection, setSelectedTransection] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_GET_WALLET(params);
      console.log("wallet", newData);
      setData(newData?.wallets);
      setLoading(false);
      setPagination({
        ...pagination,
        total: newData?.pagination?.totalWallets,
      }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const handleView = async (record) => {
    setViewModalVisible(true);
    console.log("record", record);

    try {
      setLoadingTransection(true)
      let respon = await API_GET_TRANSECTIONS(record?.user?._id);
      setSelectedTransection(respon);
      console.log("respons transection", respon);
      setLoadingTransection(false)

    } catch (error) {
      console.error("Error deleting store:", error);
      message.error(error?.response?.data?.message);
      setLoadingTransection(false)

    }
  };

  const handleViewModalOk = () => {
    // Implement view store logic here
    console.log("Viewing store:", selectedTransection);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };
  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  return (
    <div>
      <div className=" mb-6 mt-6 flex justify-between">
        {/* <Input
          className="border-none"
          placeholder={t("Search by name")}
          prefix={<SearchOutlined />}
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200 }}
        /> */}

        {/* <Link
          to={"/admin/lusers/create-user"}
          className="linear p-[4px 11px] flex h-11 w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-[14px] text-base font-semibold text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400  dark:text-white dark:active:bg-brand-200 "
        >
          + {t("Create User")}
        </Link> */}
      </div>
      <Table
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record.id} // Assuming each record has a unique id
        // rowClassName={getRowClassName} // Apply alternating row colors
        scroll={{ x: true }}
      >

        <Column
          title={t("Profile Picture")}
          dataIndex="profile_image"
          key="profile_image"
          render={(text, record) => (
            <span>
              {
                <img
                  src={
                    record?.user?.profile_image?.[0]?.file_url
                      ? CONSTANTS?.IMG_DIRECTORY +
                        record?.user?.profile_image?.[0]?.file_url
                      : userplace
                  }
                  style={{
                    width: "4rem",
                    height: "4rem",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
              }
            </span>
          )}
          // width="9rem"
        />

        <Column
          title={t("User Name")}
          dataIndex="email"
          key="email"
          render={(text, record) => (
            <span>
              {record?.user?.first_name + " " + record?.user?.last_name}
            </span>
          )}
        />

        <Column
          title={t("Wallet Balance")}
          dataIndex="balance"
          key="balance"
          render={(text, record) => (
            <span className="flex items-center gap-2">
              {Number(record?.balance).toFixed(2) + " SAR"} <MdAccountBalance />
            </span>
          )}
        />

        <Column
          title={t("User Email")}
          dataIndex="email"
          key="email"
          render={(text, record) => <span>{record?.user?.email}</span>}
        />

        <Column
          title={t("Phone No")}
          dataIndex="phone_no"
          key="phone_no"
          render={(text, record) => <span>{record?.user?.phone_no}</span>}
        />
        {/* <Column
          title={t("Address")}
          dataIndex="location"
          key="location"
          // render={(text, record) => <span>{record?.laundry?.[0]}</span>}
        /> */}

        <Column
          title={t("Actions")}
          key="actions"
          render={(text, record) => (
            // <Space size="middle">
            <div>
              <Button
                type="default"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
                style={{ marginLeft: "5px" }}
              ></Button>
            </div>
            // </Space>
          )}
        />
      </Table>
      <Modal
        visible={viewModalVisible}
        onOk={handleViewModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "67rem" }}
        className="order-modal aasa"
      >
        <div className="mb-6">
          <TransactionTable selectedTransection={selectedTransection} loadingTransection={loadingTransection} />
        </div>
      </Modal>
      {/* View Store Modal */}
    </div>
  );
};

export default WalletTable;
